import { CalendarDays, Home, Package, UserRound } from 'lucide-react'
import { NavLink } from 'react-router-dom'

import { cn } from '@/lib/cn'

import { useKitchenStore } from '../kitchenStore'

export function BottomNav() {
  const slug = useKitchenStore((state) => state.slug)
  const items = [
    { to: `/k/${slug}`, label: 'Home', Icon: Home },
    { to: '/orders', label: 'Orders', Icon: Package },
    { to: '/plans', label: 'Plans', Icon: CalendarDays },
    { to: '/profile', label: 'Profile', Icon: UserRound },
  ]
  return (
    <nav
      aria-label="Primary"
      className="grid shrink-0 grid-cols-4 border-t border-line/70 bg-surface/95 pt-1.5 pb-[max(0.375rem,var(--safe-bottom))] shadow-[0_-8px_20px_-14px_rgb(18_41_28/30%)] backdrop-blur-md"
    >
      {items.map(({ to, label, Icon }) => (
        <NavLink
          key={to}
          to={to}
          viewTransition
          className={({ isActive }) =>
            cn(
              'group flex min-h-12 flex-col items-center justify-center gap-0.5 rounded-control text-[0.6875rem] font-bold transition',
              isActive ? 'text-brand' : 'text-ink-faint hover:text-ink-soft',
            )
          }
          onClick={() => {
            if (window.location.pathname === to) {
              document
                .querySelector('.page-scroll')
                ?.scrollTo({ top: 0, behavior: 'smooth' })
            }
          }}
        >
          {({ isActive }) => (
            <>
              <span
                className={cn(
                  'grid h-7 w-12 place-items-center rounded-full transition-all duration-300 ease-spring group-active:scale-90 motion-reduce:group-active:scale-100',
                  isActive ? 'bg-brand-tint' : 'scale-90',
                )}
              >
                {/* Re-keyed on activation so the icon pops as the tab lands */}
                <span
                  key={isActive ? 'on' : 'off'}
                  className={cn('grid', isActive && 'animate-pop')}
                >
                  <Icon aria-hidden="true" className="size-5" />
                </span>
              </span>
              <span>{label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
